/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonaResponse } from './PersonaResponse';
import {
    PersonaResponseFromJSON,
    PersonaResponseFromJSONTyped,
    PersonaResponseToJSON,
    PersonaResponseToJSONTyped,
} from './PersonaResponse';
import type { ClassifierResponse } from './ClassifierResponse';
import {
    ClassifierResponseFromJSON,
    ClassifierResponseFromJSONTyped,
    ClassifierResponseToJSON,
    ClassifierResponseToJSONTyped,
} from './ClassifierResponse';

/**
 * 
 * @export
 * @interface PersonaGroupUsersResponse
 */
export interface PersonaGroupUsersResponse {
    /**
     * 
     * @type {number}
     * @memberof PersonaGroupUsersResponse
     */
    groupId: number;
    /**
     * 
     * @type {string}
     * @memberof PersonaGroupUsersResponse
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PersonaGroupUsersResponse
     */
    biasIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PersonaGroupUsersResponse
     */
    narrativeMappingIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PersonaGroupUsersResponse
     */
    userCount: number;
    /**
     * 
     * @type {Array<PersonaResponse>}
     * @memberof PersonaGroupUsersResponse
     */
    users: Array<PersonaResponse>;
    /**
     * 
     * @type {ClassifierResponse}
     * @memberof PersonaGroupUsersResponse
     */
    classifier?: ClassifierResponse | null;
}

/**
 * Check if a given object implements the PersonaGroupUsersResponse interface.
 */
export function instanceOfPersonaGroupUsersResponse(value: object): value is PersonaGroupUsersResponse {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('biasIds' in value) || value['biasIds'] === undefined) return false;
    if (!('narrativeMappingIds' in value) || value['narrativeMappingIds'] === undefined) return false;
    if (!('userCount' in value) || value['userCount'] === undefined) return false;
    if (!('users' in value) || value['users'] === undefined) return false;
    return true;
}

export function PersonaGroupUsersResponseFromJSON(json: any): PersonaGroupUsersResponse {
    return PersonaGroupUsersResponseFromJSONTyped(json, false);
}

export function PersonaGroupUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaGroupUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
        'name': json['name'],
        'biasIds': json['bias_ids'],
        'narrativeMappingIds': json['narrative_mapping_ids'],
        'userCount': json['user_count'],
        'users': ((json['users'] as Array<any>).map(PersonaResponseFromJSON)),
        'classifier': json['classifier'] == null ? undefined : ClassifierResponseFromJSON(json['classifier']),
    };
}

export function PersonaGroupUsersResponseToJSON(json: any): PersonaGroupUsersResponse {
    return PersonaGroupUsersResponseToJSONTyped(json, false);
}

export function PersonaGroupUsersResponseToJSONTyped(value?: PersonaGroupUsersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
        'name': value['name'],
        'bias_ids': value['biasIds'],
        'narrative_mapping_ids': value['narrativeMappingIds'],
        'user_count': value['userCount'],
        'users': ((value['users'] as Array<any>).map(PersonaResponseToJSON)),
        'classifier': ClassifierResponseToJSON(value['classifier']),
    };
}

